import type { HTMLAttributes } from "react";

import { cn } from "@/lib/cn";

interface OverlayProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * 特定の要素に対してローディングやモーダルなどのオーバーレイを表示するためのコンポーネント。
 * 親要素に position: relative が必要です。
 *
 */

export const Overlay = ({ className, children, ...props }: OverlayProps) => (
  <div
    className={cn(
      "absolute inset-0 z-50 flex items-center justify-center",
      "bg-background/80",
      "rounded-sm",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
